'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';
import Toggle from '@/components/ui/Toggle';

export default function KidTopBar() {
  const [quietOcean, setQuietOcean] = useState(false);

  return (
    <div className="fixed top-0 left-0 right-0 z-20 px-6 py-4 flex items-center justify-between"
      style={{ background: 'linear-gradient(180deg, rgba(2,24,32,0.95) 0%, rgba(2,24,32,0) 100%)' }}
    >
      <div className="flex items-center gap-3">
        <AppLogo size={28} />
        <span className="font-semibold text-sm text-foreground">Ocean Explorer</span>
      </div>

      <div className="flex items-center gap-4">
        {/* Quiet ocean toggle */}
        <div className="flex items-center gap-2 bg-card/40 border border-border/50 rounded-full px-3 py-1.5 backdrop-blur-sm">
          <Icon name="SpeakerXMarkIcon" size={14} className="text-kid-blue" />
          <Toggle size="sm" checked={quietOcean} onChange={setQuietOcean} />
          <span className="text-[11px] text-kid-blue font-medium hidden sm:block">Quiet Ocean</span>
        </div>

        {/* Navigation links */}
        <Link
          href="/ocean-guardian-mode"
          className="flex items-center gap-1.5 px-3 py-1.5 bg-kid-ocean/20 border border-kid-ocean/30 rounded-full text-xs font-semibold text-kid-blue hover:bg-kid-ocean/30 transition-colors"
        >
          <Icon name="ShieldCheckIcon" size={14} className="text-kid-blue" />
          <span className="hidden sm:block">Guardian Mode</span>
        </Link>

        <Link
          href="/parent-teacher-dashboard"
          className="w-8 h-8 rounded-full bg-muted/50 border border-border/50 flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Parent dashboard"
        >
          <Icon name="UserGroupIcon" size={14} />
        </Link>
      </div>
    </div>
  );
}